import React, { FC } from 'react';

import { TileContainer, DetailsText } from './tilesView.sc';
import DOMPurify from 'dompurify';
import { marked } from 'marked';

interface TilesProps {
  text: string;
}

export const TilesView: FC<TilesProps> = ({ text }): React.ReactElement => {
  const sanitizedText = DOMPurify.sanitize(
    marked.parse(text.replace(/\n/g, '\n\r'), {
      breaks: true,
      gfm: true,
      pedantic: false,
    }),
  );

  return (
    <TileContainer>
      <DetailsText dangerouslySetInnerHTML={{ __html: sanitizedText }} />
    </TileContainer>
  );
};
